import { Container } from '@acies/core';
import Label from './label';

export default class LabelText extends Container {
	public set label(value: string) {
		this.#labelChild.text = value;
	}

	public get label(): string {
		return this.#labelChild.text;
	}

	public set text(value: string) {
		this.#textChild.text = value;
	}

	public get text(): string {
		return this.#textChild.text;
	}

	#labelChild: Label;
	#textChild: Label;
	public constructor(label = '', text = '') {
		super();
		this.alignment = 'left';
		this.gapHorizontal = 8;
		this.#labelChild = new Label();
		this.#labelChild.text = label;
		this.#labelChild.variant = 'light';
		this.#textChild = new Label();
		this.#textChild.text = text;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponents([this.#labelChild, this.#textChild]);
	}
}
customElements.define('ac-label-text', LabelText);
